var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStatusCompleted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6.5,
    r: 6,
    fill: "#48BB78"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_626_11351)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.97747 3.62957C10.0946 3.74677 10.1605 3.90572 10.1605 4.07144C10.1605 4.23717 10.0946 4.39611 9.97747 4.51332L5.29289 9.1979C5.23098 9.25982 5.15748 9.30894 5.07659 9.34246C4.99569 9.37597 4.90899 9.39322 4.82143 9.39322C4.73387 9.39322 4.64716 9.37597 4.56627 9.34246C4.48538 9.30894 4.41188 9.25982 4.34997 9.1979L2.02247 6.87082C1.96278 6.81316 1.91516 6.7442 1.88241 6.66795C1.84965 6.59169 1.83241 6.50968 1.83169 6.42669C1.83097 6.34371 1.84678 6.26141 1.87821 6.1846C1.90963 6.10779 1.95604 6.038 2.01472 5.97932C2.07341 5.92064 2.14319 5.87423 2.22 5.8428C2.29681 5.81138 2.37911 5.79557 2.4621 5.79629C2.54508 5.79701 2.6271 5.81425 2.70335 5.847C2.7796 5.87976 2.84857 5.92737 2.90622 5.98707L4.82122 7.90207L9.0933 3.62957C9.15134 3.57149 9.22026 3.52542 9.29612 3.49398C9.37197 3.46255 9.45328 3.44637 9.53539 3.44637C9.6175 3.44637 9.6988 3.46255 9.77466 3.49398C9.85051 3.52542 9.91943 3.57149 9.97747 3.62957Z",
    fill: "white",
    fillOpacity: 0.87
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_626_11351"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white",
    transform: "translate(1 1.49998)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusCompleted);
export default __webpack_public_path__ + "static/media/StatusCompleted.276343888f23e39bb5b89d46cf3c5d99.svg";
export { ForwardRef as ReactComponent };